import { Constants } from '@repobit/dex-constants';
import { loadScript } from "@repobit/dex-utils";
import { ENVIRONMENTS } from './typeDefinitions';

declare global {
  interface Window {
    BD: {
      state: {
        launchScript: string
      }
    }
  }
}

export default abstract class Launch {
  public static async load(environment: ENVIRONMENTS): Promise<void> {
    if (window.BD.state.launchScript) {
      return;
    }

    window.BD.state.launchScript = `${Constants.ADOBE_MC_URL_ENV_MAP.get(environment)}`;
    await loadScript(window.BD.state.launchScript);
  }
}

window.BD = window.BD || {};
window.BD.state = window.BD.state || {};
